import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import consts from '../../constant';
import { useSelector } from 'react-redux';
import Loadingpage from '../../Components/Loadingpage/Loadingpage';

/**
 * PrivateRoute - Ensures the user is logged in
 */
export const PrivateRoute = () => {
  const token = localStorage.getItem("Jetix");
  const base = consts.route;

  if (!token) return <Navigate to={`/${base}`} replace />;

  return <Outlet />;
};

/**
 * ProtectedRoute - Ensures the user has a specific permission
 * @param {string} permission - The permission required to access the route
 */
export const ProtectedRoute = ({ permission }) => {
  console.log("🚀 ~ ProtectedRoute ~ permission:", permission)

  const token = localStorage.getItem("Jetix");
  const { permissions, role, loading } = useSelector((state) => state.user);
  const base = consts.route;

  // If no token, redirect to login
  if (!token) {
    return <Navigate to={`/${base}`} replace />;
  }

  // If role is empty, we are likely still loading the user profile
  if (role === "" || loading) {
    return <Loadingpage />;
  }

  // Admin and Superadmin can access everything
  if (role === "admin" || role === "superadmin") {
    return <Outlet />;
  }

  // If no permissions or permission not matching, redirect
  if (permission) {
    const isAllowed = permissions.some(p => p.toLowerCase().trim() === permission.toLowerCase().trim());
    if (!isAllowed) {
      
      // If they are trying to access dashboard but not allowed, send them to their first allowed page
      if (window.location.pathname === `/${base}/dashboard` || window.location.pathname === `/${base}`) {
          const permissionRoutes = {
            "users": "/usersHistory",
            "users wallet history": "/users",
            "crypto history": "/crypto/highlow",
            "trade settings": "/tradesetting",
            "deposit": "/deposit",
            "withdraw": "/withdraw",
            "pairs": "/pairs",
            "supports": "/supports",
            "settings": "/settings",
            "under maintenance": "/under-maintenance",
            "announcements": "/announcements",
            "sub admin": "/subadmin/rolemanage"
          };
          const firstAllowed = permissions.find(p => permissionRoutes[p.toLowerCase().trim()]);
          if (firstAllowed) {
            return <Navigate to={`/${base}${permissionRoutes[firstAllowed.toLowerCase().trim()]}`} replace />;
          }
          return <Navigate to={`/${base}/page404`} replace />;
      } else {
         return <Navigate to={`/${base}/dashboard`} replace />;
      }
    }
  }

  return <Outlet />;
};

/**
 * PublicRoute - Ensures authenticated users cannot access public routes (like login)
 * If logged in, redirects to the first available authorized page.
 */
export const PublicRoute = () => {
  const token = localStorage.getItem("Jetix");
  const base = consts.route;

  // If already logged in → redirect away from login
  if (token) {
    return <Navigate to={`/${base}/dashboard`} replace />;
  }

  return <Outlet />;
};
